import { render, staticRenderFns } from "./VenueCampaignEmail.vue?vue&type=template&id=1b8c8c25&"
import script from "./VenueCampaignEmail.vue?vue&type=script&lang=js&"
export * from "./VenueCampaignEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports